export const fileUploadInitialFormData: IBillingUploadForm = {
    year: `${new Date().getFullYear()}`,
    month: "",
    providerID: ""
}